<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('OtherPlatform.list.Search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('OtherPlatform.list.CompanyName') }}</label>
                        <InputText id="title" :value="name" type="text" :placeholder="$t('OtherPlatform.list.SBName')" v-model="company_name" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('OtherPlatform.list.DateofRequest') }}</label>
                        <Calendar :value="start_date" :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="from_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3" id="nohead">
                        <!-- <label for="pass">{{ $t('Purchase.list.End Date') }}</label> -->
                        <Calendar :value="end_date" :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="to_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('OtherPlatform.list.Status') }}</label>
                        <Dropdown v-model="status" :options="statusdropdown" optionLabel="name" optionValue="code" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" />
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                         <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button>  -->
                    </div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchpOtherPost"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetOtherPost"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('OtherPlatform.list.Heading') }}</h5>
                    </div>
                    <!-- <div>
                        <router-link :to="'/AddProductCategory'">
                            <Button label="Primary" class="p-mr-2 p-mb-2"><i class="pi pi-download p-mr-2"></i>{{ $t('Add New') }}</Button>
                        </router-link>
                        <router-link :to="''">
                            <Button label="Primary" class="p-mr-2 p-mb-2"><i class="pi pi-download p-mr-2"></i>{{ $t('Upload Excel') }}</Button>
                        </router-link>
                        <Button label="Primary" class="p-mr-2 p-mb-2" @click="exceldownload"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button>
                    </div> -->
                </div>
                <div class="p-mb-4 p-mb-lg-0 page">
                    <label for="order"
                        >{{ $t('OtherPlatform.list.Record') }}: {{ pagination.total_records }}
                        <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                    </label>
                    <div style="display: flex; float: right">
                        <Dropdown v-model="sortByValue" :options="sort_by" optionValue="value" optionLabel="label" placeholder="정렬 기준" @change="sortingOrdering" />
                        &nbsp;&nbsp;&nbsp;
                        <Dropdown v-model="sortOrderValue" :options="sort_order" optionValue="value" optionLabel="label" placeholder="정렬 순서" @change="sortingOrdering" />
                    </div>
                </div>
                <br />
                <DataTable :value="OtherPlatforms" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :loading="loading1" :rowHover="true" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('OtherPlatform.list.No')" style="width: 5%">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('OtherPlatform.list.Recruiter’semail')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            {{ data.email }}
                        </template>
                    </Column>
                    <Column field="company_name" :header="$t('OtherPlatform.list.CompanyName')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">User Type</span>
                            {{ data.company_name }}
                        </template>
                    </Column>
                    <Column field="created_at" :header="$t('OtherPlatform.list.RequestedDate')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">User Type</span>
                            {{ formatRangeDate(data.created_at) }}
                        </template>
                    </Column>
                    <Column field="status" :header="$t('OtherPlatform.list.Status')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">User Type</span>
                            <P id="round" v-if="data.status === 0" style="color: red; border: 1px solid red; display: inline-block; padding: 4px 15px">{{ $t('Requested') }}</P>
                            <p id="round" v-else-if="data.status === 1" style="color: black; border: 1px solid black; display: inline-block; padding: 4px 15px">{{ $t('Completed') }}</p>
                            <p id="round" v-else style="color: #a4a4a4; border: 1px solid #a4a4a4; display: inline-block; padding: 4px 15px">{{ $t('Declined') }}</p>
                        </template>
                    </Column>
                    <Column :header="$t('OtherPlatform.list.Action')" style="width: 5%">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <span v-if="data.is_apply === '1' || data.status === 2">
                                    <Button :label="$t('OtherPlatform.list.Accept')" class="p-button p-mr-2" disabled style="border-color: black"> </Button>
                                </span>
                                <span v-else>
                                    <router-link :to="'/PostOtherPlatform/AddJobPost/' + data.id + '/' + data.reqruiter_id"><Button :label="$t('OtherPlatform.list.Accept')" class="p-button2 p-mr-2"> </Button> </router-link>
                                </span>
                                <span v-if="data.status === 2 || data.status === 1 || data.is_apply === '1'">
                                    <Button :label="$t('OtherPlatform.list.Reject')" class="p-button p-mr-2" disabled style="border-color: black"></Button>
                                </span>
                                <span v-else>
                                    <Button :label="$t('OtherPlatform.list.Reject')" class="p-button2 p-mr-2" @click="openResponsive(data.id)"></Button>
                                </span>
                                <span v-if="data.status === 2 || data.status !== 1 || data.status === 0">
                                    <Button :label="$t('OtherPlatform.list.View')" class="p-button p-mr-2" disabled style="border-color: black"></Button>
                                </span>
                                <span v-else>
                                    <router-link :to="'/PostOtherPlatform/JobPostDetails/' + data.job_id"><Button :label="$t('OtherPlatform.list.View')" class="p-button2 p-mr-2"></Button> </router-link>
                                </span>
                                <!--<Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>

                    <!--  -->
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Dialog modal :header="$t('OtherPlatform.list.Alert')" v-model:visible="displayResponsive" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '36vw' }">
        <p class="text-choose">
            <b>{{ $t('OtherPlatform.list.ConfirmText') }}</b>
        </p>
        <div class="p-grid p-formgrid p-mb-3">
            <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                <br />
                <!-- <Dropdown v-model="dropdownValue" modelValue="dropdownValues[0].name" :options="dropdownValues" optionLabel="code" :placeholder="status" /> -->
                <div :class="`${error.Reasons ? 'p-invalid' : ''}`" id="accesscheck">
                    <div>
                        <input type="radio" id="bg1" value="타 서비스에서 구인 정보를 찾을 수 없습니다. 직접 등록해 주세요" name="MS" v-model="rejection_message" @change="ShowHide()" />
                        <label for="2">{{ $t('OtherPlatform.list.Reason1') }}</label>
                    </div>
                    <div>
                        <input type="radio" id="bg2" value="회원 정보가 불충분하여 검색이 불가능합니다. 직접 등록을 해주십시오" name="MS" v-model="rejection_message" @change="ShowHide()" />
                        <label for="3">{{ $t('OtherPlatform.list.Reason2') }}</label>
                    </div>
                    <div>
                        <input type="radio" id="bg3" value="등록 불가능한 업종/내용입니다" name="MS" v-model="rejection_message" @change="ShowHide()" />
                        <label for="4">{{ $t('OtherPlatform.list.Reason3') }}</label>
                    </div>
                    <div>
                        <input type="radio" id="bg4" value="등록 신청이나 구인 정보가 너무 많아 선택에 어려움이 있습니다." name="MS" v-model="rejection_message" @change="ShowHide()" />
                        <label for="5">{{ $t('OtherPlatform.list.Reason4') }}</label>
                    </div>
                    <div>
                        <input type="radio" id="other" value="others" name="MS" @click="Select()" />
                        <label for="6">{{ $t('OtherPlatform.list.Reason5') }}</label>
                    </div>
                </div>
                <div class="text-red" v-if="!rejection_message">{{ error.rejection_message }}</div>
            </div>
        </div>
        <!-- <div class="p-col-12 p-md-12" id="reason" v-if="!"></div> -->
        <div class="p-col-12 p-md-12" id="reason" v-if="pleaseenter">
            <textarea
                :style="error?.rejection_message ? 'border: 1px solid red' : ''"
                type="text"
                :placeholder="$t('OtherPlatform.list.DescPlace')"
                id="title2"
                v-model="rejection_message"
                @keydown.space="preventLeadingSpace"
                style="width: 100%; margin-left: 0px; margin-top: 14px"
                rows="5"
                cols="30"
            ></textarea>
            <div class="text-red" v-if="pleaseenter && !rejection_message">{{ '내용을 입력해주세요.' }}</div>
        </div>
        <div class="p-col-12 p-md-12" id="reason" v-else></div>
        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('OtherPlatform.list.Confirm')" icon="pi pi-check" @click="RejectPost(id)" id="reject" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('OtherPlatform.list.Cancel')" icon="pi pi-replay" @click="closeResponsive" class="p-button p-button p-button-outlined" />
            </div>
        </template>
    </Dialog>
</template>

<script>
// import { useRoute } from 'vue-router';
import ValidateRejectedReason from '../../validations/OtherJobPosts/ValidateRejectedReason';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import OtherPlatformService from '../../service/API/OtherPlatformService';
// import axios from 'axios';
import utils from '@/service/utils';
import moment from 'moment';
// // import ProductService from '../service/ProductService';
import axios from 'axios';
export default {
    data() {
        return {
            date: null,
            selected: [],
            selectedItemss: '',
            start_date: '',
            end_date: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            dropdownValue: null,
            dropdownValues: '',
            SeconddropdownValues: '',
            SeconddropdownValue: null,
            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            Primarydropdowns: '',
            Primarydropdown: [
                { name: 'Cooking and serving', code: 'Cooking and serving' },
                { name: 'Driving/Delivery/Logistics', code: 'Driving/Delivery/Logistics' },
                { name: 'Construction, civil engineering, labor', code: 'Construction, civil engineering, labor' },
                { name: 'Culture, leisure, life', code: 'Culture, leisure, life' },
                { name: 'service', code: 'service' },
                { name: 'Office/Accounting/IT', code: 'Office/Accounting/IT' },
                { name: 'Sales and consultation', code: 'Sales and consultation' },
                { name: 'Nursing, nursing, medical care', code: 'Nursing, nursing, medical care' },
            ],
            statusdropdowns: '',
            statusdropdown: [
                { name: '신청됨', code: '0' },
                { name: '반려됨', code: '2' },
                { name: '완료됨', code: '1' },
            ],
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'Statistical' },
                { name: 'Coupon', code: 'Coupon' },
                { name: 'Survey reminder', code: 'Survey reminder' },
                { name: 'Manual', code: 'Manual' },
            ],
            pets: [
                { name: 'Yes', code: 'Yes' },
                { name: 'No', code: 'No' },
            ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            Ntype: '',
            // start_date: '',
            // end_date: '',
            id: '',
            notification_type: '',
            productCategoryStatus: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            user_type: '',
            from_date: '',
            to_date: '',
            displayResponsive: false,
            OtherPlatforms: [],
            others: false,
            a: '',
            b: '',
            c: '',
            d: '',
            reason: '',
            company_name: '',
            created_at: '',
            status: '',
            rejection_message: '',
            pleaseenter: false,
            sort_order: [
                { value: 'asc', label: '오름차순' },
                { value: 'desc', label: '내림차순' },
            ],
            sortOrderValue: '',
            sort_by: [
                // { value: 'id', label: 'ID' },
                { value: 'company_name', label: '회사명' },
                { value: 'created_at', label: '신청 날짜' },
            ],
            sortByValue: '',
            SearchTo: '',
            SerachFrom: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.otherPlatformService = new OtherPlatformService();
    },
    mounted() {
        // this.getOtherlist();
        this.storageData = localStorage.getItem('OtherPlatForm') ? JSON.parse(localStorage.getItem('OtherPlatForm')) : '';

        if (this.storageData != '') {
            this.OtherPlatformPagination = this.storageData.current_page;
            this.status = this.storageData.status == undefined ? '' : this.storageData.status;
            this.company_name = this.storageData.company_name == undefined ? '' : this.storageData.company_name;
            let FromDate = this.storageData.from_date ? new Date(this.storageData.from_date) : '';
            this.from_date = FromDate;
            let ToDate = this.storageData.to_date ? new Date(this.storageData.to_date) : '';
            this.to_date = ToDate;
        }
        if (this.OtherPlatformPagination == '' || this.OtherPlatformPagination == null) {
            if (this.company_name || this.from_date || this.to_date || this.status) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    company_name: this.storageData.company_name == undefined ? '' : this.storageData.company_name,
                    status: this.storageData.status == undefined ? '' : this.storageData.status,
                    from_date: this.from_date == undefined || NaN ? '' : this.from_date ? this.from_date : '',
                    to_date: this.to_date == undefined || NaN ? '' : this.to_date ? this.to_date : '',
                };
                this.getOtherlist(searchLocalParams);
            } else {
                this.getOtherlist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.OtherPlatformPagination,
                limit: this.pagination.pagination_limit,
                company_name: this.storageData.company_name == undefined ? '' : this.storageData.company_name,
                status: this.storageData.status == undefined ? '' : this.storageData.status,
                from_date: this.from_date == undefined || NaN ? '' : this.from_date ? this.from_date : '',
                to_date: this.to_date == undefined || NaN ? '' : this.to_date ? this.to_date : '',
            };
            this.getOtherlist(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getOtherlist({ limit: val, page: 1 });
        },
    },
    methods: {
        getOtherlist(data) {
            // const OthersPlatformParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            //     status: this.status,
            //     company_name: this.company_name,
            //     from_date: this.from_date,
            //     to_date: this.to_date,
            // };
            this.loading1 = true;
            this.otherPlatformService
                .getOhterPlatformList(data)
                .then((res) => {
                    this.OtherPlatforms = res.data.data;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading1 = true;
            localStorage.setItem(
                'OtherPlatForm',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    status: this.status,
                    company_name: this.company_name,
                    from_date: this.SerachFrom,
                    to_date: this.SearchTo,
                })
            );
            this.otherPlatformService
                .getOhterPlatformList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    status: this.status,
                    company_name: this.company_name,
                    from_date: this.SerachFrom,
                    to_date: this.SearchTo,
                    sortBy: this.sortByValue,
                    sortOrder: this.sortOrderValue,
                })
                .then((res) => {
                    this.OtherPlatforms = res.data.data;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        openResponsive(id) {
            this.displayResponsive = true;
            this.getOtherlist();
            this.id = id;
        },
        closeResponsive() {
            this.displayResponsive = false;
            this.getOtherlist();
        },
        sortingOrdering() {
            // console.log('sortingOrdering');
            this.loading = true;

            let SortParams = {
                page: 1,
                limit: this.pagination.pagination_limit,
                status: this.status,
                company_name: this.company_name,
                from_date: this.from_date,
                to_date: this.to_date,
                sortBy: this.sortByValue,
                sortOrder: this.sortOrderValue,
            };
            // this.loading = true;
            this.otherPlatformService
                .getOhterPlatformList(SortParams)
                .then((res) => {
                    this.OtherPlatforms = res.data.data;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch(() => {
                    this.OtherPlatforms = [];
                    this.loading1 = false;
                });
        },
        // selects() {
        //     let xyz = [];
        //     let data = this.selected;
        //     for (var a = 0; a < data.length; a++) {
        //         xyz.push(data[a].id);
        //     }
        //     this.selectedItemss = xyz.toString();
        //     if (this.calendarValue !== '') {
        //         this.calendarValue = this.calendarValue.toISOString().slice(0, 10);
        //     }
        //     if (this.calendarValue1 !== '') {
        //         this.calendarValue1 = this.calendarValue1.toISOString().slice(0, 10) + 1;
        //     }
        // },
        resetOtherPost() {
            this.from_date = '';
            this.to_date = '';
            this.status = '';
            this.company_name = '';
            localStorage.setItem('OtherPlatForm', '');
            // this.pagination.pagination_limit = '';
            this.getOtherlist({ limit: this.pagination.pagination_limit, page: this.pagination.page });
            window.location.reload();
        },

        RejectPost(id) {
            var self = this;
            let vcheckData = {
                rejection_message: this.rejection_message,
            };

            const { isInvalid, error } = ValidateRejectedReason(vcheckData);
            if (isInvalid) {
                self.error = error;
                console.log(error);
            } else {
                self.error = '';
                axios({ method: 'put', url: `api/v1/admin/post-from-other-platform-request/request-decline/${id}`, data: { rejection_message: this.rejection_message } })
                    .then(function (response) {
                        // this.$router.push({ name: 'Banner Management' });
                        console.log(response);

                        self.$toast.add({ severity: 'info', summary: '확인.', detail: '반려 메세지가 성공적으로 전송 되었습니다.', life: 3000 });
                        self.displayResponsive = false;
                        self.getOtherlist();
                        self.rejection_message = '';
                        self.pleaseenter = false;
                        console.log(response);
                    })
                    .catch(function (err) {
                        if (err.response.data.error === 'Job Seeker Resume Has Been Already Sent To Recruiter') {
                            self.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '해당 구직자의 이력서는 이미 추천이 완료 되었습니다.', life: 3000 });
                            self.displayResponsive = false;
                            self.getOtherlist();
                        }
                    });
            }
        },
        Select() {
            this.pleaseenter = true;
            this.rejection_message = '';
        },
        ShowHide() {
            this.pleaseenter = false;
        },

        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '-' + mm + '-' + dd);
        },

        searchpOtherPost() {
            if (this.from_date == '' && this.to_date == '' && this.status == '' && this.company_name == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else if (this.from_date !== '' && this.to_date == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else if (this.from_date == '' && this.to_date !== '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else if (this.from_date > this.to_date) {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else {
                if (this.from_date != '') {
                    this.SerachFrom = this.addDay(this.from_date);
                } else {
                    this.SerachFrom = '';
                }
                if (this.to_date != '') {
                    this.SearchTo = this.addDay(this.to_date);
                } else {
                    this.SearchTo = '';
                }
                localStorage.setItem(
                    'OtherPlatForm',
                    JSON.stringify({
                        page: 1,
                        // limit: this.pagination.pagination_limit,
                        status: this.status,
                        company_name: this.company_name,
                        from_date: this.SerachFrom,
                        to_date: this.SearchTo,
                    })
                );
                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    status: this.status,
                    company_name: this.company_name,
                    from_date: this.SerachFrom,
                    to_date: this.SearchTo,
                };
                this.loading = true;
                this.otherPlatformService
                    .getOhterPlatformList(searchParams)
                    .then((res) => {
                        this.OtherPlatforms = res.data.data;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading1 = false;
                        console.log(res);
                    })
                    .catch(() => {
                        this.OtherPlatforms = [];
                        this.loading1 = false;
                    });
                // this.getMSlist();
            }
        },
        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        formatRangeDate(date) {
            if (date === undefined || date === '') {
                return '';
            }
            return moment(new Date(date)).format('YYYY/MM/DD');
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    border: 1px solid blue;
    color: black;
}

// .p-button1 {
//     background-color: black;
//     color: white;
//     border-color: black;
// }
button.p-button.p-component.p-button2.p-component.p-button.p-button-sm.p-mr-2.p-mb-2 {
    border: 1px solid blue;
    color: black;
    background: white;
}
div#nohead {
    margin-top: 25px;
}
p.text-choose {
    text-align: center;
    margin-top: 15px;
}
div#accesscheck {
    width: max-content;
    display: inline-block;
    line-height: 30px;
    padding-left: 30px;
}
p#round {
    border-radius: 12px;
    border: 1px solid black;
    color: black;
}
button.p-button.p-component.p-button2:hover {
    background: black;
    color: white;
    // border: 1px solid black;
    border-color: black;
}
button.p-button.p-component.p-button2 {
    background: rgb(255, 253, 253);
    color: rgb(10, 10, 10);
    border: 1px solid black;
    border-color: black;
}
</style>
